import isNil from 'lodash/isNil'

const getValidProducts = (products) => {
  return products
    .filter(item => !isNil(item.productInfo.name) && !isNil(item.productInfo.price))
}

export { getValidProducts }
